export default {
  // Page titles
  title: 'Templates',
  new_template: 'New Template',
  edit_template: 'Edit Template',
  template_detail: 'Template Details',

  // Descriptions
  description: 'Manage document templates',
  new_description: 'Create a new document template',
  edit_description: 'Update template configuration',

  // Labels
  labels: {
    template_name: 'Template Name',
    document_type: 'Document Type',
    schema_fields: 'Schema Fields',
    template_settings: 'Template Settings',
  },

  // Placeholders
  placeholders: {
    template_name: 'e.g., Standard Lease Agreement',
  },

  // Document types
  types: {
    all: 'All Types',
    lease: 'Lease Contract',
    invoice: 'Invoice',
    receipt: 'Receipt',
    contract: 'Contract',
    tax_invoice: 'Tax Invoice',
    legal_notice: 'Legal Notice',
    wht_50_tawi: 'Withholding Tax Certificate (50 Tawi)',
    expense_reimbursement_receipt: 'Expense Reimbursement Receipt',
  },
  updated_on: 'Updated {{date}}',

  // Editor
  editor: {
    visual_mode: 'Visual',
    json_mode: 'JSON',
    template_designer: 'Template Designer',
    json_editor: 'JSON Editor',
    full_screen: 'Full Screen',
    exit_full_screen: 'Exit Full Screen',
    json: 'JSON',
    preview: 'Preview',
    fields_count: 'Fields ({{count}})',
    no_fields: 'No fields yet.',
    invalid_json: 'Invalid JSON: {{error}}',
    show_sample_data: 'Show sample data',
    hide_sample_data: 'Hide sample data',
    editing_in_fullscreen: 'Editing in fullscreen. Exit fullscreen to use this editor.',
    json_format_hint: 'Edit the template structure using pdfme-compatible JSON format.',
    json_placeholder: 'Enter template JSON...',
    drag_to_move: 'Drag to move',
  },

  // Preview
  preview: {
    title: 'Template Preview',
    json_title: 'Template JSON',
    visual: 'Preview',
  },

  // Actions
  actions: {
    add_template: 'Add Template',
    create_template: 'Create Template',
    copy_json: 'Copy JSON',
    download_json: 'Download JSON',
  },

  // Empty states
  empty: {
    title: 'No templates',
    description: 'Create your first document template.',
    not_found: 'Template not found',
  },

  // Setup guide
  setup_guide: {
    title: 'Welcome to Templates',
    description:
      'Templates let you design documents for leases, invoices, and receipts. Create a template once, then use it whenever you generate documents.',
    step_1_title: 'Create a template',
    step_1_description: 'Choose a document type and give it a name.',
    step_2_title: 'Design with visual editor',
    step_2_description: 'Use the drag-and-drop designer to add text, images, and layout elements.',
    step_3_title: 'Add dynamic variables',
    step_3_description:
      'Insert {{customer.name}} and other variables that auto-fill with data.',
  },

  // Variable Guide
  variables: {
    title: 'Available Variables',
    description: 'Use these variables in text field content. They will be replaced with actual values when generating documents.',
    copy_hint: 'Click to copy',
    copied: 'Copied!',
    category_property: 'Property',
    category_unit: 'Unit',
    category_lease: 'Lease',
    category_customer: 'Customer',
    category_signature: 'Signatures',
    'property.name': 'Property name',
    'property.address': 'Property address',
    'unit.number': 'Unit number/name',
    'unit.price': 'Monthly rent price',
    'lease.deposit': 'Security deposit amount',
    'lease.move_in_fee': 'Move-in fee amount',
    'lease.keycard_deposit': 'Key-card deposit amount',
    'lease.started_at': 'Lease start date',
    'lease.ended_at': 'Lease end date',
    'lease.lease_code': 'Lease reference code',
    'lease.lease_code_qr': 'Lease code as QR code (use with barcodes.qrcode field)',
    'customer.name': 'Tenant full name',
    'customer.phone': 'Tenant phone number',
    'signature.landlord': 'Landlord signature (image field)',
    'signature.tenant': 'Tenant signature (image field)',
  },

  // Messages
  messages: {
    delete_confirm: 'Delete template "{{name}}"? This action cannot be undone.',
    created: 'Template created successfully',
    updated: 'Template updated successfully',
    deleted: 'Template deleted successfully',
    copied: 'JSON copied to clipboard',
  },
}
